// extracted by mini-css-extract-plugin
export default {"category_row":"styles_category_row__kBbDo"};